import type { ReactNode } from 'react';

type RCtaVariant = 'primary' | 'outline' | 'ghost';

type Props = {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: RCtaVariant;
  mini?: boolean;
};

const KIND: Record<RCtaVariant, string> = {
  primary: 'dsb-primary',
  outline: 'dsb-secondary',
  ghost: 'dsb-tertiary',
};

const RCta = ({ children, onClick, disabled, loading, variant = 'primary', mini }: Props) => (
  <button
    type="button"
    className={['dsb', KIND[variant], mini ? 'dsb-m' : 'dsb-l', 'dsb-block'].join(' ')}
    disabled={disabled || loading}
    aria-busy={loading}
    onClick={() => onClick?.()}
  >
    {loading ? (
      <span className="rg-btn-dots">
        <i />
        <i />
        <i />
      </span>
    ) : (
      children
    )}
  </button>
);

export { RCta };
